export default __webpack_public_path__ + "static/media/trash.3c13320e.webp";